import React, { useEffect } from 'react';
import MaterialOrderGrid from '../../../features/cfi/material-order-grid/components/MaterialOrderGrid';
import { useTitle } from "../../../contexts/title";

export default function MaterialOrdersPage() {

	const pageTitle = useTitle();
	useEffect(() => {
		pageTitle.setTitle('Material Orders')
	}, [pageTitle]);

	return (
		<React.Fragment>
			<div className={'content-block'}>
				<MaterialOrderGrid />
			</div>
		</React.Fragment>
	)
} 
